<template>
    <div>
        <template v-if="wholesaler === true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Shop </h1>
            </div>
            <div class="global-main">
                <form id="companyForm" @submit.prevent="addShop">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Shop Name <em class="required">*</em></label>
                            <input v-model="form.shop_name" type="text" name="shop_name" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('shop_name') }">
                            <has-error :form="form" field="shop_name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Shop Owner Name <em class="required">*</em></label>
                            <input v-model="form.owner_name" type="text" name="owner_name" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('owner_name') }">
                            <has-error :form="form" field="owner_name"></has-error>
                        </div>
                        <!-- <div class="form-group">
                            <label> Shop Keeper CNIC <em class="required">*</em></label>
                            <input v-model="form.cnic" type="text" name="cnic" @keypress="isNumber($event)" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('cnic') }" minlength="13" maxlength="13">
                            <has-error :form="form" field="cnic"></has-error>
                        </div> -->
                        <div class="form-group">
                            <label> Phone <em class="required">*</em></label>
                            <input v-model="form.phone" type="text" @keypress="isNumber($event)" name="phone" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('phone') }" maxlength="12">
                            <has-error :form="form" field="phone"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Address <em class="required">*</em></label>
                            <textarea v-model="form.address" name="address" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('address') }"></textarea>
                            <has-error :form="form" field="address"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/shops" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="wholesaler === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="wholesaler === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    shop_name : '',
                    owner_name : '',
                    // cnic : '',
                    phone : '',
                    address : '',
                    fromWeb : 1,
                }),
                wholesaler: null,
            }
        },
        methods: {
            addShop() {
                this.$Progress.start();
                this.form.post('api/addShop')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code != 200) {
                            this.$Progress.fail();
                            this.showToastBox('error',res.data.msg);
                        } else {
                            this.$Progress.finish();
                            this.showToastBox('success','Shop added successfully');
                            this.$router.push('/shops');
                        }
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('wholesaler').then(result => {
                this.wholesaler = result.wholesaler;
            }).then(result => {
                if(this.wholesaler == true){
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>